<template>
<div id="contents">

  <div id="privacypolicy" class="page_contents">

    <div id="privacypolicy_contents">
      <div class="page_header">
        <h1 class="page_header_title">
          <span>個人情報について02</span>
        </h1><!-- .top_sec_title -->
      </div><!-- .page_header -->

      <div id="privacypolicy_contents_main">

        <div class="policy_box">
          <h2>テレビ朝日映像　個人情報保護方針</h2>
          <div class="policy_box_inner">
            <p>テレビ朝日映像株式会社（以下、当社）では、個人情報を保護することが重要であると認識するとともに、当社の社会的責任、責務であると考えます。</p>
            <p>また、個人情報の保護に関する法律では、報道目的で扱う個人情報をそれ以外の目的で扱う個人情報と分けて考えています。当社では、報道目的の個人情報について、報道目的以外の個人情報と区別して扱います。しかし、どちらの個人情報も法の趣旨にのっとりその保護に努めます。</p>
            <p>1.個人情報は、あらかじめ利用目的を明確にし、適法かつ公正な手段によって取得します。<br />2.個人情報は、事前に明確にした目的の範囲内でのみ取り扱います。<br />3.個人情報は、法令に定める場合を除き、あらかじめ本人の同意を得ることなく第三者に提供はしません。<br />4.個人情報は、正確で最新の内容を保つよう努めるとともに、本人から開示・訂正・利用停止等の求めがある場合は、速やかにこれに対応します。<br />5.個人情報は、厳重に管理し、不正アクセスや情報の紛失、破壊、改ざん、遺漏等が起きないよう安全対策を講じます。<br />6.番組を制作するために取得した個人情報は、番組上でのみ、もしくは番組制作のための資料としてのみ、利用します。<br />7.当社は、個人情報の保護に関する法律およびその他の規範、業界ガイドラインを遵守するとともに、個人情報を保護のための管理体制の継続的な改善に取り組んでいきます。</p>
          </div><!-- .policy_box_inner -->
        </div><!-- .policy_box -->

        <div class="policy_box">
          <h2>個人情報に関するお問合せ先</h2>
          <div class="policy_box_inner">
            <p>〒106-0032<br />東京都港区六本木1－1－1　アーク放送センター<br />テレビ朝日映像株式会社　経営管理局「個人情報」担当<br />WEBサイトからのお問い合わせは <router-link v-bind:to="{ name : 'contact' }" class="">こちら</router-link></p>
          </div><!-- .policy_box_inner -->
        </div><!-- .policy_box -->

      </div><!-- #privacypolicy_contents_main -->

    </div><!-- #privacypolicy_contents -->
  </div><!-- #privacypolicy -->



</div><!-- #contents -->
</template>

<script>
export default {
  name: 'privacypolicy',
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/privacypolicy02.vue